import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PI } from '../../constants-types/PI.model';
import {
    InvitationActivityResponse,
    UserAccessRequest
} from '../../core-data-model/InvitationAndSharingActivity';
import { ApiService } from '../../system-services';

@Injectable({ providedIn: 'root' })
export class InvitationAndSharingActivityApi {
    constructor(private api: ApiService) {}

    async updateUserModuleAccess(
        moduleUserInvite: UserAccessRequest
    ): Promise<boolean> {
        const url = `/api/v1/companies/${moduleUserInvite.companyGuid}/users/module/requestaccess`;
        return this.api
            .post<UserAccessRequest>(
                url,
                moduleUserInvite,
                PI.appSettings.userApiUrl
            )
            .then(([_responseBody, httpResponse]) => {
                if (httpResponse.status !== HttpStatusCode.Accepted) {
                    return Promise.reject();
                }
                return true;
            });
    }

    async updateUserEntityAccess(
        entityUserInvite: UserAccessRequest
    ): Promise<boolean> {
        const url = `/api/v1/companies/${entityUserInvite.companyGuid}/users/module/requestaccess/entity`;
        return this.api
            .post<UserAccessRequest>(
                url,
                entityUserInvite,
                PI.appSettings.userApiUrl
            )
            .then(([_responseBody, httpResponse]) => {
                if (httpResponse.status !== HttpStatusCode.Accepted) {
                    return Promise.reject();
                }
                return true;
            });
    }

    async updateUserShareviteAccess(
        shareviteUserInvite: UserAccessRequest
    ): Promise<boolean> {
        const url = `/api/v1/companies/${shareviteUserInvite.companyGuid}/users/sharevite/requestaccess`;
        return this.api
            .post<UserAccessRequest>(
                url,
                shareviteUserInvite,
                PI.appSettings.userApiUrl
            )
            .then(([response]) => response);
    }

    async getInvitationActivityForUser(
        companyId: string,
        id: string
    ): Promise<InvitationActivityResponse> {
        const url = `/api/v1/companies/${companyId}/invitation/${id}`;
        return this.api
            .get<InvitationActivityResponse>(
                url,
                null,
                null,
                PI.appSettings.userApiUrl
            )
            .then(([response, _httpResponse]) => response)
            .catch(() => null);
    }
}
